import { ShareResponse } from "../models/ResponseModels/ShareResponse";
import { DetailSectionConfig } from "../Utilities";

export const sharedLandingDetailsSections: DetailSectionConfig<ShareResponse>[] =
  [
    {
      id: "file-section",
      title: "File",
      fields: [
        { id: "title", label: "Title", key: "title_image" },
        { id: "file_extension", label: "Extension", key: "file_extension" },
        { id: "type", label: "Type", key: "image_type" },
        {
          id: "file-Size",
          label: "Size",
          key: "fileSizeBytes",
          formatter: (v: string) =>
            v ? `${(parseFloat(v) / 1024).toFixed(2)} KB` : "",
        },
      ],
    },
    {
      id: "dimension-section",
      title: "Dimension",
      fields: [
        {
          id: "width",
          label: "Width",
          key: "width",
          formatter: (v: string) => (v ? `${v} px` : ""),
        },
        {
          id: "height",
          label: "Height",
          key: "height",
          formatter: (v: string) => (v ? `${v} px` : ""),
        },
      ],
    },
    {
      id: "general-section",
      title: "General",
      fields: [
        { id: "description", label: "Description", key: "description" },
        {
          id: "collection_title",
          label: "Collection Title",
          key: "title_workorder_linked",
        },
        { id: "channel", label: "Channel", key: "channel_workorder" },
        { id: "creator", label: "Creator", key: "creator" },
        { id: "subject_person", label: "Person Shown", key: "subject_person" },
      ],
    },
    {
      id: "usage-rights-section",
      title: "Usage Rights",
      fields: [{ id: "copyright", label: "Copyright", key: "copyright" }],
    },
  ];
